export enum SurveyApiType {
  Survey = 'SURVEY',
  Election = 'ELECTION',
  Exam = 'EXAM',
  ElectionCandidacy = 'ELECTION_CANDIDACY',
  SportsCapabilities = 'SPORTS_CAPABILITIES',
  CulturalCapabilities = 'CULTURAL_CAPABILITIES',
  Workshops = 'WORKSHOPS',
  GraduationCelebrations = 'GRADUATION_CELEBRATIONS',
  Camps = 'CAMPS',
}
